"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "US/Alaska": "-09:00",
  "US/Central": "-05:00",
  "US/Eastern": "-05:00",
  "US/Mountain": "-06:00",
  "US/Pacific": "-08:00",
  "US/Hawaii": "-10:00"
};